import React from "react";
import { useGetCustomerTagsQuery } from "@tiny/api";
import { subscribersStatuses } from "../SubscribersList.helpers";
import { CustomerStatus, CustomerStatuses } from "../SubscribersList.types";

import { FilterSubscribersDialogProps } from "./FilterSubscribersDialog.types";

export function useFilterSubscribersDialog(
  props: FilterSubscribersDialogProps
) {
  const { onSave, statuses, open, tags: tagsProp } = props;

  const [selected, setSelected] = React.useState<CustomerStatuses>([]);

  const [tags, setTags] = React.useState<string[]>(tagsProp);

  const { data: { tags: customerTags = [] } = {} } = useGetCustomerTagsQuery({
    enabled: open,
    staleTime: 0,
    select(data) {
      return {
        ...data,
        tags: data.tags?.sort(Intl.Collator().compare),
      };
    },
  });

  const isSelected = React.useCallback(
    (status: CustomerStatus) => {
      return selected.includes(status);
    },
    [selected]
  );

  const selectAll = React.useCallback((checked: boolean) => {
    if (checked) {
      setSelected(subscribersStatuses);
    } else {
      setSelected([]);
    }
  }, []);

  const selectStatus = React.useCallback(
    (status: CustomerStatus, checked: boolean) => {
      if (checked) {
        setSelected((prev) => [...prev, status]);
      } else {
        setSelected((prev) => prev.filter((i) => i !== status));
      }
    },
    []
  );

  const save = React.useCallback(() => {
    onSave(selected, tags);
  }, [onSave, selected, tags]);

  React.useEffect(() => {
    if (open) {
      setSelected(statuses);
      setTags(tagsProp);
    }
  }, [open, statuses, tagsProp]);

  const allChecked = subscribersStatuses.length === selected.length;
  const statusesLength = selected.length;
  const tagsLength = tags.length;

  return {
    selectAll,
    allChecked,
    save,
    selectStatus,
    isSelected,
    customerTags,
    statusesLength,
    tags,
    setTags,
    tagsLength,
  };
}
